









import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";

@Component({
  components: {
    "cprod-prov-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue")
  }
})
export default class CProdProvKeyActionsComponent extends Mixins(
  CProdProvInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !!this.$_.filter(
      this.cProdProvData.cProdProvFunctions,
      ({ highlight }) => !!highlight
    )?.length;
  }
}
